import { render, staticRenderFns } from "./telMsg.vue?vue&type=template&id=6c7b6daf&scoped=true"
import script from "./telMsg.vue?vue&type=script&lang=js"
export * from "./telMsg.vue?vue&type=script&lang=js"
import style0 from "./telMsg.vue?vue&type=style&index=0&id=6c7b6daf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7b6daf",
  null
  
)

export default component.exports